import script from "./HeroldAtLocationModal.vue?vue&type=script&setup=true&lang=js"
export * from "./HeroldAtLocationModal.vue?vue&type=script&setup=true&lang=js"

import "./HeroldAtLocationModal.vue?vue&type=style&index=0&id=6952c9c0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6952c9c0"]])

export default __exports__